<template>
    <el-dialog
        :visible="visible"
        ref="DetailDialog"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="accounting-edit-dialog ah-detail-dialog"
        top="10vh"
        width="550px"
        append-to-body
        @open="onOpen"
        @close="onClose()"
    >
        <template slot="title">
            <span v-if="!form.sno">新增會計明細科目</span>
            <span v-else>編輯會計明細科目</span>
        </template>
        <div class="ah-page">
            <div class="ah-container">
                <el-form ref="form" :model="form" :rules="rules" v-loading="isLoading" class="accounting-setting-edit-dialog" label-position="top">
                    <div class="first-form-row">
                        <el-form-item prop="accno" label="會計明細科目代號">
                            <accno-input v-model="form.accno" :disabled="form.defaultAccount" @blur="onAccnoInputBlur" />
                        </el-form-item>
                        <el-form-item prop="accnam" label="會計明細科目名稱（中文）">
                            <el-input v-model="form.accnam" placeholder="科目名稱" maxlength="50" show-word-limit></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item prop="accnaM_E" label="會計明細科目名稱（英文）">
                        <el-input v-model="form.accnaM_E" placeholder="科目英文名稱" maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item prop="ismonth" label="">
                        <el-checkbox v-model="form.ismonth">月計項目</el-checkbox>
                    </el-form-item>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item prop="gccnO_SNO" label="統制科目">
                                <el-select
                                    v-model="form.gccnO_SNO"
                                    :disabled="form.defaultAccount"
                                    placeholder="請選擇"
                                    filterable
                                    :loading="isGaapFetching"
                                    loading-text="更新列表中"
                                    style="width: 100%"
                                    @change="onChangeGcc"
                                >
                                    <el-option v-for="item in reconciliationAccountList" :key="item.sno" :label="`${item.gccno} - ${item.gccnam}`" :value="item.sno" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="dC_TYP" label="科目屬性" style="opacity: 0.6">
                                <el-radio-group v-model="dC_TYP" disabled size="small" class="dc-selector">
                                    <el-radio :label="1" class="radio-option">
                                        <div class="dc-option-item d-option">
                                            <div>借</div>
                                        </div>
                                    </el-radio>
                                    <el-radio :label="2" class="radio-option">
                                        <div class="dc-option-item c-option">
                                            <div>貸</div>
                                        </div>
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item v-if="isGaapShow" prop="gaap" label="資產負債表項目" style="opacity: 0.6">
                        <el-select v-model="gaap" disabled placeholder="請輸入">
                            <el-option v-for="item in gaapList" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>
                </el-form>
                <span class="dialog-footer">
                    <el-button v-if="form.sno" v-loading="isSubmitting" type="danger" :disabled="form.defaultAccount" @click="onDelete">刪除</el-button>
                    <div v-else />
                    <div class="button-set">
                        <el-button :disabled="isSubmitting" @click="onClose()">取消</el-button>
                        <el-button v-if="!form.sno" v-loading="isSubmitting" type="primary" @click="onAdd">確定</el-button>
                        <el-button v-else v-loading="isSubmitting" type="primary" @click="onUpdate">確定</el-button>
                    </div>
                </span>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import { gaapList } from '@/assets/commonData/options';
import AccnoInput from '@/components/ui/AccnoInput.vue';

export default {
    components: { AccnoInput },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: null,
        },
        typ: {
            type: Number,
            default: 0,
        },
        isGaapShow: Boolean,
    },
    data() {
        const validateAccno = (rule, value, callback) => {
            if (!value) {
                callback(new Error('請輸入會計明細科目代號'));
            } else if (value.match(/^[1-9][0-9][0-9][0-9](-*)[0-9]*$/) === null) {
                callback(new Error('請輸入有效的科目代號'));
            } else {
                callback();
            }
        };
        return {
            isLoading: false,
            isSubmitting: false,
            isGaapFetching: false,

            reconciliationAccountList: [],
            gaapList,

            dC_TYP: null,
            gaap: null,
            form: {
                sno: 0,
                accno: '',
                accnam: '',
                accnaM_E: '',
                gccnO_SNO: '',
                ismonth: true,
                defaultAccount: false,
            },
            rules: {
                accno: [
                    {
                        required: true,
                        validator: validateAccno,
                        trigger: 'blur',
                    },
                ],
                accnam: [{ required: true, message: '請輸入會計明細科目名稱（中文）', trigger: 'blur' }],
                gccnO_SNO: [{ required: true, message: '請選擇統制科目', trigger: 'change' }],
            },
        };
    },
    methods: {
        async fetchReconciliationAccount() {
            if (!this.form.accno || this.form.accno[0] === '0') {
                this.reconciliationAccountList = [];
                return;
            }

            if (this.reconciliationAccountList.length && this.reconciliationAccountList[0].gccno[0] === this.form.accno[0]) return;

            try {
                this.isGaapFetching = true;
                const resp = await this.$api({
                    url: '/ReconciliationAccount/Query',
                    method: 'GET',
                    params: { Typ: this.form.accno[0] },
                });
                this.reconciliationAccountList = resp.data.settings;
            } finally {
                this.isGaapFetching = false;
            }
        },
        onChangeGcc(val) {
            const GCC = _.find(this.reconciliationAccountList, ['sno', val]);
            if (!GCC) return;

            this.dC_TYP = GCC.dC_TYP;
            this.gaap = GCC.gaap;
        },
        async onOpen() {
            try {
                this.isLoading = true;

                this.form.sno = this.data.sno;
                this.form.accno = this.data.accno;
                this.form.accnam = this.data.accnam;
                this.form.accnaM_E = this.data.accnaM_E;
                this.form.gccnO_SNO = this.data.gccnO_SNO;
                this.dC_TYP = this.data.dC_TYP;
                this.gaap = this.data.gaap;
                this.form.defaultAccount = this.data.defaultAccount;
                if (this.data.ismonth === undefined) this.form.ismonth = true;
                else this.form.ismonth = this.data.ismonth;

                await this.fetchReconciliationAccount();

                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            } finally {
                this.isLoading = false;
            }
        },

        onAdd() {
            try {
                this.isSubmitting = true;
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        await this.$api({
                            url: '/AccountingSettingPage/AddSetting',
                            method: 'POST',
                            data: { ...this.form },
                        });
                        this.$message.success(`${this.form.accno} 科目已新增`);
                        this.onClose(this.form.accno);
                    }
                });
            } finally {
                this.isSubmitting = false;
            }
        },
        onUpdate() {
            try {
                this.isSubmitting = true;
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        if (+this.form.accno[0] !== this.typ) {
                            await this.$confirm(`送出修改後此會計科目的類型將會從${this.typ}更新為${+this.form.accno[0]}`, {
                                confirmButtonText: '確定',
                                cancelButtonText: '取消',
                            });
                        }
                        await this.$api({
                            url: '/AccountingSettingPage/UpdateSetting',
                            method: 'POST',
                            data: { ...this.form, sot: 0 },
                        });
                        this.$message.success(`${this.form.accno} 科目已儲存`);
                        this.onClose(true);
                    }
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isSubmitting = false;
            }
        },
        async onDelete() {
            try {
                await this.$confirm(`確定要刪除此會計科目 ${this.form.accno} ？`, {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isSubmitting = true;

                await this.$api({
                    url: '/AccountingSettingPage/DeleteSetting',
                    method: 'POST',
                    data: { sno: this.form.sno },
                });
                this.$message.success(`${this.form.accno} 科目已刪除`);
                this.onClose(true);
            } finally {
                this.isSubmitting = false;
            }
        },

        onClose(refresh) {
            this.$emit('close', refresh);
        },

        async onAccnoInputBlur() {
            if (!this.form.accno) return;

            await this.fetchReconciliationAccount();

            // 預選統制科目
            const baseAccno = this.form.accno.split('-')[0];
            const gccSameItem = this.reconciliationAccountList.find((x) => x.gccno === baseAccno);
            if (gccSameItem) {
                this.form.gccnO_SNO = gccSameItem.sno;
                this.onChangeGcc(gccSameItem.sno);
            } else if (this.form.gccnO_SNO) {
                this.form.gccnO_SNO = null;
                this.dC_TYP = null;
                this.gaap = null;
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            }
        },
    },
};
</script>

<style lang="scss">
.accounting-edit-dialog {
    .ah-container {
        margin-top: 30px;
    }
    .first-form-row {
        display: flex;
        > :first-child {
            width: 150px;
            margin-right: 10px;
        }
        > :last-child {
            flex: 1;
        }
    }

    .radio-option {
        display: flex;
        align-items: center;
    }

    .dc-selector {
        display: flex;
    }
    .dc-option-item {
        &.d-option {
            color: #f55c5c;
        }
        &.c-option {
            color: #56c500;
        }
    }

    .dialog-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
